import PaymentMethodModel from "../model/payment_method_model";

export const toPaymentMethodModel = async (paymentMethod, encryptionService) => {
  const decryptedData = await encryptionService.decrypt(paymentMethod);
  return new PaymentMethodModel({
    id: decryptedData.paymentMethodId,
    firstName: decryptedData.firstName,
    lastName: decryptedData.lastName,
    cardNumber: decryptedData.cardNumber,
    cardExpiry: decryptedData.cardExpiry,
  });
};
